import { StaffDashboardPage } from '@/components/dashboard/staff-dashboard-page'

export function AdminDashboard() {
  return <StaffDashboardPage basePath="/admin" showCreditsWidget showOpenRequestsPanel />
}
